import {
  Archive,
  AudioFile,
  Code,
  Description,
  Image,
  InsertDriveFile,
  PictureAsPdf,
  VideoFile,
} from '@mui/icons-material';
import Chip, { ChipProps } from '@mui/material/Chip/Chip';

interface DecoratedChipProps extends ChipProps {
  url: string;
}

export function getFileIcon(fileUrl: string): JSX.Element {
  const extension = fileUrl.split('.').pop()?.toLowerCase();

  switch (extension) {
    case 'pdf':
      return <PictureAsPdf />;
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'webp':
      return <Image />;
    case 'mp4':
    case 'webm':
    case 'avi':
      return <VideoFile />;
    case 'mp3':
    case 'wav':
    case 'ogg':
      return <AudioFile />;
    case 'js':
    case 'ts':
    case 'jsx':
    case 'tsx':
    case 'html':
    case 'css':
      return <Code />;
    case 'zip':
    case 'rar':
    case '7z':
      return <Archive />;
    case 'doc':
    case 'docx':
    case 'txt':
      return <Description />;
    default:
      return <InsertDriveFile />;
  }
}

export function getFileName(fileUrl: string): string {
  console.log('File URL at getFileName:', fileUrl);
  let fullFileName = fileUrl.split('/').pop()?.trim() ?? '';
  if (fullFileName.length === 0) fullFileName = 'Untitled File';
  if (fullFileName.length > 20) {
    return `${fullFileName.slice(0, 17)}...`;
  }
  return fullFileName;
}

function DecoratedChip({ url, ...props }: DecoratedChipProps) {
  return <Chip icon={getFileIcon(url)} label={getFileName(url)} {...props} />;
}

export default DecoratedChip;
